import "core-js/modules/es.array.index-of";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.object.keys";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React from 'react';
export var ZoomToControl = function ZoomToControl(_ref) {
  var title = _ref.title,
      props = _objectWithoutPropertiesLoose(_ref, ["title"]);

  return /*#__PURE__*/React.createElement("div", {
    className: "mapboxgl-ctrl mapboxgl-ctrl-group"
  }, /*#__PURE__*/React.createElement("button", _extends({
    className: "mapboxgl-ctrl-icon mapboxgl-ctrl-us",
    title: title
  }, props)));
};
export default ZoomToControl;